/**
 * Surfaces an "edited elsewhere" notice when the autosave hits a
 * 409 from the optimistic-concurrency check. The save thunk
 * automatically refetches the canonical state before this banner
 * renders, so by the time the user sees it the local changes are
 * already replaced with the server's truth. The banner exists
 * purely to inform — without it, the user would just see their
 * unsaved changes vanish and be confused.
 */
import { useAppDispatch, useAppSelector } from "@/state/hooks";
import { dismissWorkspaceConflict } from "@/state/slices/workspacesSlice";
import styles from "./ConflictBanner.module.css";

export function ConflictBanner() {
  const dispatch = useAppDispatch();
  const conflictName = useAppSelector((s) => s.workspaces.conflictName);
  if (!conflictName) return null;
  return (
    <div className={styles.banner} role="alert">
      <span className={styles.text}>
        Workspace <strong>{conflictName}</strong> was edited in another
        session. Your local changes have been replaced with the
        latest version from the server.
      </span>
      <button
        type="button"
        className={styles.dismiss}
        onClick={() => dispatch(dismissWorkspaceConflict())}
      >
        Dismiss
      </button>
    </div>
  );
}
